// extracted by mini-css-extract-plugin
export var container = "Container-module--container--78520";
export var form = "Container-module--form--2db18";
export var mainBoard = "Container-module--mainBoard--839c4";
export var noPadding = "Container-module--noPadding--cebba";
export var responsive = "Container-module--responsive--fff6c";
export var tablet = "Container-module--tablet--414b4";